import { useQuery } from 'react-query';

import { getProgramGeneralHierarchyList as queryFn } from 'api/endPoints/getProgramGeneralHierarchyList';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetProgramGeneralHierarchyList = (params) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['GetProgramGeneralHierarchyList', params],
        queryFn: () => queryFn(),
        cacheTime: 0,
    });
};

export interface QueryResponse {
    children: QueryResponse[];
    id: number;
    name: string;
    parentUUID: string | null;
    type: string;
    uuid: string;
}
